import {css} from '../utils';

export default css`
    /* Each additional selector increases our styles' specificity. This trick
   allows us to override bootstrap styles. */
    .section.section {
        /* We have to keep the inline padding at 48px because of our control
        panel button. It'd be great to make this responsive in the future if we
        can find another way to display the button. */
        padding: ${({theme}) => theme.section_padding ?? '24px'};
        display: flex;
        flex-direction: column;
        /* We don't use section_gap between the section heading and the section
        contents so that the heading always has a little extra whitespace to
        breathe. */
        gap: 16px;
    }
`;
